import React from 'react';
import { AppBar, Button, ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { NavLink, NavLinkProps } from 'react-router-dom';

export const HeaderBar = styled(AppBar)({
  boxShadow: 'none',
  backgroundColor: 'transparent',
  color: 'black',
});

interface NavigationLinkProps extends ButtonProps {
  to: NavLinkProps['to'];
  replace?: NavLinkProps['replace'];
}

export const NavigationLink = styled(
  ({ to, replace, ...props }: NavigationLinkProps) => (
    <Button component={NavLink} to={to} replace={replace} {...props} />
  )
)(({ theme }) => ({
  textTransform: 'none',
  margin: theme.spacing(1),
  color: theme.palette.primary.main,
  border: `1px solid transparent`,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&.active': {
    borderColor: theme.palette.primary.main,
  },
}));

export const UserMenuButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginLeft: theme.spacing(1),
  '& .MuiAvatar-root': {
    width: 26,
    height: 26,
    // marginRight: theme.spacing(1),
  },
  '& .MuiSvgIcon-root': {
    // marginRight: -theme.spacing(1),
  },
}));

export const ExternalNavigationLink = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  margin: theme.spacing(1),
  color: theme.palette.primary.main,
  border: `1px solid transparent`,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const AddOrganizationButton = styled(Button)({
  backgroundColor: 'black', // Replace with your color
  color: 'white',
  '&:hover': {
    backgroundColor: 'darkgrey', // Replace with your hover color
  },
});
